module.exports = __webpack_public_path__ + "media/images/checkout/amex-0b5261cc35068f48e0e70320b76b38e6.png";